import type { Feature, FeatureModule } from '../../../../types';
import { featureList } from '../../../helpers';
import { ASSETS_COLORS_FEATURE_GROUP } from './group';

export const ASSETS_COLORS_FEATURES = {
  READ: {
    guid: 'f1d5e739-7c2a-4b18-a462-3b9c0f5d0001',
    name: 'assets:colors:read',
    description: 'View organization color scheme settings',
    action: 'read',
    product: 'account',
    parentGuid: ASSETS_COLORS_FEATURE_GROUP.guid,
  },
  UPDATE: {
    guid: 'f1d5e739-7c2a-4b18-a462-3b9c0f5d0002',
    name: 'assets:colors:update',
    description: 'Edit organization color scheme settings',
    action: 'update',
    product: 'account',
    parentGuid: ASSETS_COLORS_FEATURE_GROUP.guid,
  },
} as const satisfies Record<string, Feature>;

export { ASSETS_COLORS_FEATURE_GROUP } from './group';

export const ASSETS_COLORS_MODULE: FeatureModule = {
  product: 'account',
  groups: [ASSETS_COLORS_FEATURE_GROUP],
  features: featureList(ASSETS_COLORS_FEATURES),
};
